import { gql } from '@apollo/client';

export const GetRegistrationAgentVoices = gql`
    query getRegistrationAgentVoices {
        getRegistrationAgentVoices {
            success
            error
            voices {
                id
                text
                description
                previewUrl
            }
        }
    }
`;
